<template>
    <div>
        <div class="ui-datepicker-inline" ref="datepicker"></div>
        <div role="button" tabindex="0" @click="changeDateToNextWinter" class="link-small text-end px-3" v-if="isShowNextSeasonButton">
            {{nextWinterContent}}
            <ArrowRight />
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import 'jquery-ui/ui/widgets/datepicker'
import {getStartOfWinterDate} from "../logic/getStartOfWinterDate"
import ArrowRight from "./svg/common/arrow-right/index.vue"
import {defaultStartDate, winterStartMonth} from "../config/defaults"
import isWinterSeason from '../utils/isWinterSeason.ts'

export default {
    name: 'Datepicker',
    components: {
        ArrowRight
    },
    props: {
        value: Date,
        getDefaultDate: Function,
        getAvailableDates: Function,
        month: String,
        showOtherMonths: Boolean,
        contents: Object,
        store: Object,
        showNextSeasonButton: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            data: {
                obj: null,
                availableDates: {},
                currentCalendarYear: null,
                currentCalendarMonth: null
            },
            off: {},
            state: {}
        }
    },
    computed: {
        nextWinterContent() {
            const currentYear= new Date().getFullYear()
            const nextYear = currentYear + 1
            return `${this.contents.winter} ${currentYear}-${nextYear}`
        },
        
		/**
		 * Determines whether the "Next Season" button should be displayed.
		 *
		 * This method checks if the current month on the calendar is not equal to
		 * the `winterStartMonth` and also not within the winter season. If both
		 * conditions are met, it returns the value of `this.showNextSeasonButton`; 
		 * otherwise, it returns `false`.
		 *
		 * The winter season is determined by the `isWinterSeason` function, which
		 * uses the current month and year to check if it's winter.
		 *
		 * @returns {boolean} - Returns `true` if the "Next Season" button should be 
		 * displayed, otherwise returns `false`.
		 */
         isShowNextSeasonButton() {
            return this.data.currentCalendarMonth != winterStartMonth && !isWinterSeason(this.data.currentCalendarMonth, this.data.currentCalendarYear) ? this.showNextSeasonButton : false
        },
    },
    methods: {
        init: function (options) {
            var self = this
            this.data.obj.datepicker({
                dateFormat: 'dd/mm/yy',
                firstDay: 1,
                dayNamesMin: this.contents.daysOfWeek,
                monthNames: this.contents.monthNames,
                prevText: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 12L6 8L10 4" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                `,
                nextText: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 4L10 8L6 12" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        `,
                showOtherMonths: this.showOtherMonths,
                beforeShowDay: function (date) {
                    var monthStr = moment(date).format('YYYY-MM')
                    var dateStr = moment(date).format('YYYY-MM-DD')
                    var available = !!(self.data.availableDates[monthStr] && self.data.availableDates[monthStr][dateStr])
                    return [available, ,]
                },
                onChangeMonthYear: function (year, month) {
                    self.data.currentCalendarYear = year
                    var monthStr = moment(new Date(year, month - 1)).format('YYYY-MM')
                    self.updateAvailableDates(monthStr).then(function () {
                        self.data.obj.datepicker('refresh')
                        self.removeDatePickerControlHoverElement()
                    })
                },
                onSelect: function () {
                    var date = self.data.obj.datepicker('getDate')
                    self.change(date)
                },
                ...options
            }),
                setTimeout(() => {
                    self.removeDatePickerControlHoverElement()
                }, 100)
        },
        change: function (value) {
            this.$emit('change', value)
        },
        updateAvailableDates: function (monthStr, nextMonth) {
            this.data.currentCalendarMonth = +monthStr.split('-')[1]
            var self = this
            return this.getAvailableDates(monthStr, nextMonth).then(function (result) {
                self.setAvailableDates(monthStr, result)
                return result
            })
        },
        removeDatePickerControlHoverElement() {
            // Remove the mousover popover
            $('.ui-datepicker-next').removeAttr('title')
            $('.ui-datepicker-prev').removeAttr('title')
            $('.ui-datepicker-trigger').removeAttr('title')
        },
        setAvailableDates: function (monthStr, dates) {
            var self = this
            // clear available dates by months
            dates
                .reduce(function (monthStrs, date) {
                    var monthStr = date.split('-')
                    monthStr.pop()
                    monthStr = monthStr.join('-')
                    if (!monthStrs.includes(monthStr)) {
                        monthStrs.push(monthStr)
                    }
                    return monthStrs
                }, [])
                .forEach(function (monthStr) {
                    self.$set(self.data.availableDates, monthStr, {})
                })
            // set available dates
            dates.forEach(function (date) {
                var monthStr = date.split('-')
                monthStr.pop()
                monthStr = monthStr.join('-')
                self.$set(self.data.availableDates[monthStr], date, true)
            })
        },
        setDefaultDate: function (dates) {
            var defaultDate = this.getDefaultDate(dates)
            
            if (!defaultDate) {
                // If no default date and we have available dates, navigate to the first available date
                if (dates && dates.length > 0) {
                    var firstAvailableDate = new Date(dates[0])
                    var firstAvailableMonthStr = moment(firstAvailableDate).format('YYYY-MM')
                    // Load dates for the first available month if not already loaded
                    if (!this.data.availableDates[firstAvailableMonthStr] || Object.keys(this.data.availableDates[firstAvailableMonthStr]).length === 0) {
                        var self = this
                        this.updateAvailableDates(firstAvailableMonthStr, true).then(function () {
                            self.data.obj.datepicker('setDate', firstAvailableDate)
                            self.data.obj.datepicker('refresh')
                        })
                    } else {
                        this.data.obj.datepicker('setDate', firstAvailableDate)
                    }
                }
                return
            }

            this.data.obj.datepicker('destroy')
            this.init({
                defaultDate
            })
        },
        changeDateToNextWinter() {
            const date = new Date(getStartOfWinterDate())
            this.data.obj.datepicker('setDate', date)
        }
    },
    beforeDestroy: function () {
        this.data.obj.datepicker('destroy')
        this.removeDatePickerControlHoverElement()
    },
    async mounted() {
        var self = this
        this.data.obj = $(this.$refs.datepicker)
        this.init({})

        // Determine which month to load initially
        var monthStr
        const now = new Date()
        const currentMonth = now.getMonth() + 1 // 1-12
        const currentYear = now.getFullYear()
        const currentMonthStr = moment(now).format('YYYY-MM')

        // If we're past November (December or later), use the current month
        if (currentMonth > 11) {
            monthStr = currentMonthStr
        } else if (defaultStartDate) {
            // Check if we're past the defaultStartDate month
            const defaultStartDateObj = new Date(defaultStartDate)
            const defaultStartMonth = defaultStartDateObj.getMonth() + 1
            const defaultStartYear = defaultStartDateObj.getFullYear()
            
            // If current date is past the defaultStartDate month, use current month
            if (currentYear > defaultStartYear || (currentYear === defaultStartYear && currentMonth > defaultStartMonth)) {
                monthStr = currentMonthStr
            } else {
                monthStr = defaultStartDate.split('-').slice(0, 2).join('-')
            }
        } else {
            monthStr = getStartOfWinterDate()
        }

        this.updateAvailableDates(monthStr, true).then(function (dates) {
            // Check if the initial month has no dates, and if so, navigate to first available date
            var initialMonthHasDates = dates && dates.length > 0 && dates.some(function(date) {
                var dateMonthStr = date.split('-').slice(0, 2).join('-')
                return dateMonthStr === monthStr
            })
            
            if (!initialMonthHasDates && dates && dates.length > 0) {
                // Current month has no dates, navigate to first available date
                var firstAvailableDate = new Date(dates[0])
                var firstAvailableMonthStr = moment(firstAvailableDate).format('YYYY-MM')
                
                // If first available date is in a different month, load that month
                if (firstAvailableMonthStr !== monthStr) {
                    self.updateAvailableDates(firstAvailableMonthStr, true).then(function () {
                        // Set the datepicker to show the first available month and date
                        self.data.obj.datepicker('setDate', firstAvailableDate)
                        if (self.value) {
                            self.data.obj.datepicker('setDate', self.value)
                        }
                    })
                } else {
                    // First available date is in the same month, just set it
                    self.data.obj.datepicker('setDate', firstAvailableDate)
                    if (self.value) {
                        self.data.obj.datepicker('setDate', self.value)
                    }
                }
            } else {
                // Initial month has dates, use normal default date logic
                self.setDefaultDate(dates)
                if (self.value) {
                    self.data.obj.datepicker('setDate', self.value)
                }
            }
        })


    }
}
</script>
